import {
  nombresPaquetes,
  nombresTarjetasPorCodigo
} from "@/config/constants/packagesCodes.js";

describe("nombresPaquetes", () => {
  it("debe devolver el nombre del paquete a partir del codigo", () => {
    expect(nombresPaquetes("09")).toEqual("Paquete Express");
    expect(nombresPaquetes("01")).toEqual("Paquete Gold");
    expect(nombresPaquetes("07")).toEqual("Paquete Full");
    expect(nombresPaquetes("08")).toEqual("Paquete Platinum");
    expect(nombresPaquetes("04")).toEqual("Paquete Black");
    expect(nombresPaquetes("100")).toEqual("");
  });
});

describe("nombresTarjetasPorCodigo", () => {
  it("debe devolver el nombre de la tarjeta a partir del codigo", () => {
    expect(nombresTarjetasPorCodigo("CI")).toEqual("Visa Internacional");
    expect(nombresTarjetasPorCodigo("PP")).toEqual("Visa Gold");
    expect(nombresTarjetasPorCodigo("LL")).toEqual("Visa Platinum");
    expect(nombresTarjetasPorCodigo("SS")).toEqual("Visa Signature");
    expect(nombresTarjetasPorCodigo("12")).toEqual("Mastercard Internacional");
    expect(nombresTarjetasPorCodigo("13")).toEqual("Mastercard Gold");
    expect(nombresTarjetasPorCodigo("18")).toEqual("Mastercard Platinum");
    expect(nombresTarjetasPorCodigo("43")).toEqual("Mastercard Black");
  });
});
